import { useCallback } from 'react';
import { useToggle } from 'react-use';

import { useRefetchMedicalServices } from '../../../shared/queries/useRefetchMedicalServices';

import { PractitionerMedicalServiceUpdateModal } from './PractitionerMedicalServiceUpdateModal';

type PractitionerMedicalServiceUpdateModalOpenerRenderProps = { openModal: VoidFunction };

type PractitionerMedicalServiceUpdateModalOpenerProps = {
   readonly children: (renderProps: PractitionerMedicalServiceUpdateModalOpenerRenderProps) => JSX.Element;
   readonly practitionerId: number;
   readonly medicalServiceId: number;
};

export const PractitionerMedicalServiceUpdateModalOpener = (
   props: PractitionerMedicalServiceUpdateModalOpenerProps
): JSX.Element => {
   const refetchMedicalServices = useRefetchMedicalServices();
   const [modalOpened, toggleModalOpened] = useToggle(false);

   const openModal = useCallback(() => {
      toggleModalOpened(true);
   }, [toggleModalOpened]);

   const handleSuccess = useCallback(() => {
      toggleModalOpened(false);
      refetchMedicalServices();
   }, [toggleModalOpened, refetchMedicalServices]);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}
         {modalOpened ? (
            <PractitionerMedicalServiceUpdateModal
               medicalServiceId={props.medicalServiceId}
               onSuccess={handleSuccess}
               closeModal={toggleModalOpened}
               practitionerId={props.practitionerId}
            />
         ) : null}
      </>
   );
};
